import React, { Component } from 'react'
import { Query } from 'react-apollo'

import Form from './Form'
import { FIND_CONTENT } from 'graphql/queries'

import { Container, Header } from 'semantic-ui-react'
import Loader from 'components/Loader'

class NewContent extends Component {
  state = {
    showPreview: false,
    template: '',
  }

  renderNew() {
    return (
      <React.Fragment>
        <Header as="h1" content="New Content" />
        <Form />
      </React.Fragment>
    )
  }
  renderEdit() {
    const { match } = this.props

    return (
      <React.Fragment>
        <Header as="h1" content="Edit Content" />

        <Query query={FIND_CONTENT} variables={{ id: match.params.contentId }}>
          {({ data: { content }, loading }) => {
            if (loading) {
              return <Loader />
            }

            return <Form initialValues={content} />
          }}
        </Query>
      </React.Fragment>
    )
  }

  render() {
    let editMode = false
    if (this.props.location.pathname.includes('edit')) editMode = true
    return (
      <Container>{editMode ? this.renderEdit() : this.renderNew()}</Container>
    )
  }
}

export default NewContent
